const surveyCommentTag = (state = "", action) => {
  if (action.type === "UPDATECOMMENTTAG") {
    return (state = action.payload);
  } else {
    return state;
  }
};
export default surveyCommentTag;
